
































import './scss/style.scss';

import { mapState } from 'vuex';
import { Component, Vue } from 'vue-property-decorator';
import ServerTooltip from './components/ServerTooltip.vue';
import ServerCard from './components/ServerCard.vue';

@Component({
  components: {
    ServerTooltip,
    ServerCard,
  },
  computed: mapState(['servers']),
})
export default class App extends Vue {
  public created() {
    this.$store.dispatch('loadServers');
  }
}
